import { RouteConfig } from 'vue-router'

const Notify = () => import('../activity/sports-trial/ActivePage.vue')

export const notifyRoute: RouteConfig = {
  path: '/sports-trial-activity',
  name: 'sports_trail_activity',
  component: Notify,
  meta: {
    title: '体智云',
  },
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [notifyRoute]
